import { render } from "./lightbox-one.vue?vue&type=template&id=55cbe4d2"
import script from "./lightbox-one.vue?vue&type=script&lang=js"
export * from "./lightbox-one.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__